/**Dependencies */
import "./assets/css/override.css";
import "./assets/css/variables.css";
import "./locale/index";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { JulebProvider } from "./context";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { NotificationProvider } from "./providers/NotificationProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <JulebProvider>
    <BrowserRouter basename="auth">
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </BrowserRouter>
  </JulebProvider>,
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
